import { IRequestByPartnerId } from 'legacy/lut/classes/models/service'
import { PartnerPageMetric } from 'legacy/lut/configs/metrics'
import {
  fetchPartnerFlagsByIdAndType,
  fetchPartnerFlagsRequestsByIdAndType,
  mergePartnerFlags,
} from 'legacy/lut/services/partner/partnerFlags'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { RequestStatus } from 'clickNgo/configs/service/common'
import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'
import { measureRequest } from 'shared/lib/metrics'

import { GET_PARTNER_FLAGS_BY_ID_REQUEST } from '../configs'
import { selectPartnerFlags } from '../selectors'

export const getPartnerFlagsById = createAsyncThunk(
  GET_PARTNER_FLAGS_BY_ID_REQUEST,
  async ({ partnerId, options }: IRequestByPartnerId, { getState }) => {
    const user = selectUser(getState())
    const params = { partnerId }
    const fetchOptions = { ...options, cacheKey: options?.cacheKey || partnerId }
    const master = await measureRequest(PartnerPageMetric.Flags, user, () =>
      fetchPartnerFlagsByIdAndType(params, fetchOptions)
    )
    const request = await measureRequest(PartnerPageMetric.FlagRequests, user, () =>
      fetchPartnerFlagsRequestsByIdAndType(params, fetchOptions)
    )

    return mergePartnerFlags(master, request)
  },

  {
    condition({ partnerId }, { getState }) {
      if (!partnerId) {
        return false
      }

      const state = getState()
      const partnerFlags = selectPartnerFlags(state)
      if (partnerFlags.status === RequestStatus.PENDING) {
        return false
      }

      return true
    },
  }
)
